<h2 class="side-menu-title">
    <router-link v-if="to" :to="to" class="side-menu-title-link">
        {{ title }}
    </router-link>
    <span v-else class="side-menu-title-link">{{ title }}</span>
</h2>